'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

exports.cleanUsedTraits = cleanUsedTraits;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _rpUtils = require('rp-utils');

var _constants = require('../constants');

var _nonCanonical = require('./nonCanonical');

var _getDeviceType = require('./getDeviceType');

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = require('./cookie/getBettingAccountLoggedInStatus');

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = require('./cookie/getUserName');

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = require('./cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _getUTMParams = require('./utm/getUTMParams');

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _commonTraits = require('./commonTraits');

var _traits = require('../traits');

var _constants2 = require('./cookie/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

var usedTraits = {};

function cleanUsedTraits() {
    usedTraits = {};
}

var tryParseJson = function tryParseJson(json) {
    try {
        return JSON.parse(json);
    } catch (err) {
        return null;
    }
};

function setCardCustomistaion() {
    var customizationCookie = _jsCookie2.default.get('customizeSettings');

    if (!customizationCookie) {
        return {};
    }

    var getCustomizeSettings = tryParseJson(customizationCookie);

    if (!getCustomizeSettings) {
        return {};
    }

    var form = getCustomizeSettings.form,
        myNotes = getCustomizeSettings.myNotes,
        spotlights = getCustomizeSettings.spotlights,
        comments = getCustomizeSettings.comments,
        raceConditions = getCustomizeSettings.raceConditions,
        owner = getCustomizeSettings.owner,
        quotes = getCustomizeSettings.quotes,
        pedigrees = getCustomizeSettings.pedigrees,
        rtf = getCustomizeSettings.rtf,
        priceHistory = getCustomizeSettings.priceHistory,
        decimalOdds = getCustomizeSettings.decimalOdds,
        bettingForecast = getCustomizeSettings.bettingForecast,
        orderByPrice = getCustomizeSettings.orderByPrice,
        myRatings = getCustomizeSettings.myRatings,
        showPrices = getCustomizeSettings.showPrices;


    var settings = {
        betting_forecast: bettingForecast,
        comments: comments,
        decimal_odds: decimalOdds,
        form: form,
        my_notes: myNotes,
        my_ratings: myRatings,
        order_by_price: orderByPrice,
        owner: owner,
        pedigrees: pedigrees,
        price_history: priceHistory,
        quotes: quotes,
        race_conditions: raceConditions,
        rtf: rtf,
        show_prices: showPrices,
        spotlights: spotlights
    };

    return settings;
}

function identify() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    var _extends3;

    var shouldGetFromLocalStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var loggedBookmakersAccounts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    // eslint-disable-next-line no-console
    // package props has been deleted because we don't need it
    var newProps = (0, _extends6.default)({}, props);
    delete newProps.Package;
    var userIdLocal = newProps[_traits.TRAIT_USER_ID] ? newProps[_traits.TRAIT_USER_ID] : (0, _getUserId2.default)();
    var emailLocal = newProps[_traits.TRAIT_EMAIL] ? newProps[_traits.TRAIT_EMAIL] : (0, _getUserName2.default)();
    /**
     * [JP-9761] - getting all logged bookmakers accounts
     *  from local storage or from betslip-ui
     * If we are in the betslip-ui, we will get
     *  the logged bookmakers accounts from the prop
     * The needs from the flag shouldGetFromLocalStorage
     *  are because if user re-load browser we should
     *  get it from localStorage
     *  NOTE: keep in mind skybet comes like 'skybetflutter'
     */
    var loggedBookmakersFromStorage = [];
    if (shouldGetFromLocalStorage) {
        var jsonLoggedBookmakers = (0, _rpUtils.getLocalStorage)('userAccountsInfo') || {};
        loggedBookmakersFromStorage = Object.values(jsonLoggedBookmakers).filter(function (account) {
            return account.isLoggedIn;
        });

        loggedBookmakersFromStorage.forEach(function (bookmaker) {
            var key = _constants.API_NAME_TO_KEY[bookmaker.apiName];
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = true;
        });
    } else {
        /**
         * set all bookmakers to false in order to prevent
         * the case when we are not clearing someone of the bookmakers
         */
        Object.keys(_traits.TRAIT_RECENT_BOOKMAKERS).forEach(function (key) {
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = false;
        });

        loggedBookmakersAccounts.forEach(function (bookmaker) {
            var key = _constants.API_NAME_TO_KEY[bookmaker];
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = true;
        });
    }

    var checkloginCookie = (0, _getUserId2.default)();

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    properties[_traits.TRAIT_USER_NAME] = emailLocal;
    properties[_traits.TRAIT_EMAIL] = emailLocal;
    properties[_traits.TRAIT_USER_ID] = userIdLocal;

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    if (userIdLocal) {
        properties = (0, _extends6.default)({}, properties, (0, _defineProperty3.default)({}, _traits.TRAIT_USER_LAST_LOGIN_DATE, _rpCookie2.default.sharedSession.get(_constants2.COOKIE_LAST_LOGGED_IN_WEB) || (0, _rpUtils.convertToIsoUKTime)(Date.now())));
    }

    properties = (0, _extends6.default)((_extends3 = {}, (0, _defineProperty3.default)(_extends3, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends3, _traits.TRAIT_LOGGED_IN_STATUS, checkloginCookie ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends3, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends3), setCardCustomistaion(), properties, _traits.TRAIT_RECENT_BOOKMAKERS, (0, _defineProperty3.default)({}, _traits.TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS, shouldGetFromLocalStorage ? loggedBookmakersFromStorage.length : loggedBookmakersAccounts.length), (0, _getUTMParams2.default)(), newProps);

    var keys = Object.keys(properties);
    var isSameTraits = keys.every(function (prop) {
        return properties[prop] === usedTraits[prop];
    });

    if (isSameTraits) {
        // set Timeout here to fetch user-metadata after the identify call
        // removed Timeout from getUserMetaData in order to call it separately without delay
        setTimeout(function () {
            (0, _rpUtils.getUserMetaData)(userIdLocal);
        }, 1000);

        return Promise.resolve();
    }

    usedTraits = Object.assign({}, properties);

    return new Promise(function (resolve) {
        // Segment Identify event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        if (userIdLocal) {
            global.analytics.identify(userIdLocal, properties, options, resolve);
        } else {
            global.analytics.identify(properties, options, resolve);
        }

        // set Timeout here to fetch user-metadata after the identify call
        // removed Timeout from getUserMetaData in order to call it separately without delay
        setTimeout(function () {
            (0, _rpUtils.getUserMetaData)(userIdLocal);
        }, 1000);
    });
}

exports.default = identify;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/identify.js
// module id = 267
// module chunks = 0